export default {
  title: 'Nowe menu',
  headers: {
    edit_time: 'Edytuj godziny',
  },
  labels: {
    select_all: 'Zaznacz wszystko',
  },
  fields: {
    name: {
      label: 'Nazwa',
      placeholder: 'Wprowadź nazwę menu',
    },
    sorting_order: {
      label: 'Kolejność wyświetlania menu',
      placeholder: 'Wprowadź kolejność wyświetlania menu',
    },
    has_separate_schedule: {
      label: 'Różni się od standardowych godzin otwarcia',
    },
    selected_days: {
      label: 'Wybrane dni',
    },
    opening_time: {
      label: 'Godzina otwarcia',
    },
    closing_time: {
      label: 'Godzina zamknięcia',
    },
  },
  buttons: {
    add_opening_time: 'Dodaj godzinę otwarcia',
    add: 'Dodaj',
    cancel: 'Anuluj',
    save: 'Zapisz',
    close: 'Zamknij',
  },
  feedback: {
    missing_info: 'Brakujące informacje',
  },
  toasts: {
    menu_got_created: 'Menu zostało utworzone',
    menu_got_updated: 'Menu zostało zaktualizowane',
  },
};
